// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_GpS","cls2":"common-cls2_b4D common-cls1_GpS"};